import { Badge } from 'react-bootstrap';
import { FaReact, FaHtml5, FaCss3Alt, FaNodeJs, FaPython, FaJava } from 'react-icons/fa';
import { SiJavascript, SiMongodb, SiJquery} from 'react-icons/si'
import { StyledLink, StyledSpan, AccentedIndex, StyledContainer, StyledRow, StyledCol} from '../utils/styles'
import styled from 'styled-components';
import { Fade } from 'react-awesome-reveal';

const StyledBadge = styled(Badge)`
    font-size:100%;
    margin: 0.3em;
`

const About = ({id}) => {
    const one = <StyledSpan><h5><AccentedIndex>[1]</AccentedIndex></h5><h3>About me</h3></StyledSpan>
    const two = <p>Hello! My name is Prayuj. I graduated from <StyledLink target="_blank" rel="nofollow" href="https://www.sjsu.edu/cs/" className="content-hover-link">San Jose State Univeristy</StyledLink> with a Master's in Computer Science</p>
    const three = <p>I am currently a Software Dev Engineer at <StyledLink target="_blank" rel="nofollow" href="https://aws.amazon.com/iam/" className="content-hover-link">AWS</StyledLink> working in the IAM Control Plane. I worked at <StyledLink target="_blank" rel="nofollow" href="https://cimpress.com/" className="content-hover-link">Cimpress</StyledLink> as part of their Business subsidiary, <StyledLink target="_blank" rel="noreferrer" href="http://pens.com/us" className="content-hover-link">National Pen.</StyledLink></p>
    const four = <p>Here are a few technologies I am proficient in:</p>

    const technology = [
        { icon: SiJavascript, name: 'Javascript', color: '#EFD81D'},
        { icon: FaReact, name: 'React', color: '#09D8F2' },
        { icon: FaHtml5, name: 'HTML', color: '#D84924'},
        { icon: FaCss3Alt, name: 'CSS', color: '#2449D8'},
        { icon: FaNodeJs, name: 'NodeJs', color: '#6AB24D'},
        { icon: SiMongodb, name: 'Mongodb', color: '#108B4B'},
        { icon: SiJquery, name: 'jQuery', color: '#0764A4' },
        { icon: FaPython, name: 'Python', color: '#F2C53D'},
        { icon: FaJava, name: 'Java', color: '#EA2F30'}
    ]

    const five = <p style={{textAlign: 'center'}}>
        {technology.map(tech => <StyledBadge pill style={{ background: tech.color }}>
            <tech.icon /> {tech.name}
        </StyledBadge>)}
        </p>
    const items = [one, two, three, four, five]
    return (
        <StyledContainer id={id} fluid="lg">
            <StyledRow>
                <StyledCol>
                    <Fade triggerOnce = {true}>
                        {items.map((item, i) => (<div>{item}</div>
                        ))}
                    </Fade>
                </StyledCol>
            </StyledRow>
        </StyledContainer>
    );
}

export default About;
